module.exports = __webpack_public_path__ + "img/56_61.0da0a313.png";